import * as React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import { getPagination } from '../../selectors/pagination';
import { getTitle } from './utils/getTitle';
import { Title } from '../../components/Title/Title';
import { useDeviceType } from '@cian/ui-kit';

export const TitleContainer = () => {
  const { total } = useSelector(getPagination, shallowEqual);
  const counter: string = getTitle(total);
  const device = useDeviceType();

  return <Title counter={counter} withProjectsLink={device === 'desktop'} />;
};
